import { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api from '../utils/api';
import { resolveLayout } from './registry';

// Loads the user's saved layout once, resolves it against the registry, and
// returns a setter that persists changes to the server (and updates local
// state optimistically). Falls back to DEFAULT_LAYOUT if the user has never
// customized.
export function useDashboardLayout(authCtx) {
  const [layout, setLayout] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get('/auth/dashboard-layout');
        if (cancelled) return;
        setLayout(resolveLayout(data?.layout, authCtx));
      } catch {
        if (!cancelled) setLayout(resolveLayout(null, authCtx));
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = useCallback(async (next) => {
    setLayout(next);
    try {
      await api.put('/auth/dashboard-layout', { layout: next });
    } catch (err) {
      // Surface the error — a silent failure here means the user thinks
      // they've customized but lose the layout on next load. Loud is better.
      console.error('dashboard-layout save failed:', err);
      toast.error('Could not save dashboard layout — changes may be lost on reload');
    }
  }, []);

  return { layout: layout || [], loaded, save };
}
